var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Add an FTP Account ")]),
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c("ftp-account-form", {
                    on: {
                      "account-created": _vm.reloadTable
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" FTP Accounts ")]),
              _c(
                "gg-card-text",
                [
                  _c("ftp-accounts-table", {
                    attrs: {
                      loading: _vm.loading
                    },
                    on: {
                      reload: _vm.reloadTable
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }